import * as getters from './getters';
import { state as defaultState } from './state';

export default (experimentAssignment = {}) => ({
  namespaced: true,
  state: {
    ...defaultState,
    assignments: experimentAssignment.assignments || {},
    pageViewEventId: experimentAssignment.pageViewEventId || null,
  },
  getters,
});
